import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { GREEN, MessageWrapper, RED } from '../Styles';

export const ConnectionState = observer(() => {
  const {
    AuctionStore: { connected, networkConnected },
  } = useStores();

  const isConnected = connected && networkConnected;
  const connectedColor = isConnected ? GREEN : RED;
  const connectedMessage = isConnected ? 'CONNECTED' : 'NOT CONNECTED';

  return (
    <MessageWrapper
      bgColor={connectedColor}
      style={{
        width: '250px',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        flexDirection: 'row',
      }}
    >
      <i
        aria-hidden="true"
        className={`fa ${
          isConnected ? 'fa-check-circle-o' : 'fa-times-circle-o'
        } fa-2`}
      />
      {connectedMessage}
    </MessageWrapper>
  );
});

export default ConnectionState;
